import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
function HeaderIcon({hero, Icon, active, title}) {
    return (
        <div className="">   

            <div className='items-center cursor-pointer justify-around hover:bg-gray-100 px-10 p-2 rounded-xl mt-1 mb-1'>
                {hero && 
                <Icon />
                }
                {!hero && 
                <FontAwesomeIcon className={`h-6 w-6 text-gray-500 ${active && 'text-blue-500'}`} icon={Icon} />
                }       

            {/* <div className='flex items-center cursor-pointer  
                md:px-10 sm:h-14 md:hover:bg-gray-100 rounded-xl
                active:border-b-2 active:border-blue-500 group'>
                {hero && 
                <Icon className={`h-5 text-gray-500 text-center sm:h-7 mx:auto 
                group-hover:text-blue-500 ${active && 'text-blue-400' }`}
                />
                }
                {!hero && 
                <FontAwesomeIcon icon={Icon} className={`h-5 text-gray-500 text-center sm:h-6 mx:auto 
                group-hover:text-blue-500 ${active && 'text-blue-400' }`}
                />
                }             */}
            </div>                                              
        </div>        
    )
}

export default HeaderIcon
